import gql from 'graphql-tag';

export const SET_OFFER_PROPERTIES = gql`
  mutation setOfferProperties($params: SetOfferPropertiesInput!) {
    setOfferProperties(params: $params) {
      offerUuid
      offerDescription
      offerStartDate
      offerEndDate
      offerDeleted
      offerKeywords
      paymentNetworkMCC
    }
  }
`;

export default SET_OFFER_PROPERTIES;
